import {Component, OnInit} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {Observable, Subject} from 'rxjs';
import {GlobalMessagesService} from '../../../shared/services/messages/global.messages.service';
import {AddAgeRangesService} from '../../../shared/services/nso-data-portal/add-services/add-age-ranges-service';
import {AgeGroupsData} from '../../../shared/types/nso-data-portal/census-data';
import {ENTRY_STATES} from '../../../shared/types/entry/EntryStatesEnum';
import {
  AdministrationInformationRestService
} from '../../../shared/services/nso-data-portal/rest-services/administration-information-rest.service';
import {share} from 'rxjs/operators';
import {ConfirmationService} from 'primeng/api';

@Component({
  selector: 'wsd-age-group',
  templateUrl: './age-group.component.html',
  styleUrls: ['./age-group.component.css']
})
export class AgeGroupsComponent implements OnInit {

  filter = {
    name: ''
  };

  ageGroups$: Observable<AgeGroupsData[]>;

  searchChanged = new Subject<void>();

  pageSize: number = 10;

  constructor(private message: GlobalMessagesService,
              private administrationRestService: AdministrationInformationRestService,
              private addService: AddAgeRangesService,
              private translate: TranslateService,
              private confirmService: ConfirmationService) {
  }

  ngOnInit() {
    this.loadData(0);
  }

  private loadData(page: number) {
    this.ageGroups$ = this.administrationRestService.getAgeGroups().pipe(share());
  }

  modify(ageGroup) {
    this.addService.modify({...ageGroup});
  }

  create() {
    this.addService.create();
  }

  search() {
    this.searchChanged.next();
  }

  onSave(event) {
    if (event.$state === ENTRY_STATES.NEW) {
      this.administrationRestService.createAgeGroup(event).subscribe({
        next: this.handleSuccess.bind(this),
        error: this.handleError.bind(this)
      });
    } else {
      this.administrationRestService.updateAgeGroup(event).subscribe({
        next: this.handleSuccess.bind(this),
        error: this.handleError.bind(this)
      });
    }
  }

  private handleError(err) {
    this.message.showErrorMessage(err.error.message ||
      this.translate.instant('DATA_PORTAL.ADMINISTRATION.AGE_GROUPS.SAVE_ERROR_MESSAGE'));
  }

  private handleSuccess() {
    this.loadData(0);
    this.message.showSuccessMessage(this.translate.instant('DATA_PORTAL.ADMINISTRATION.AGE_GROUPS.SAVED_MESSAGE'));
  }

  delete(ageGroup) {
    this.confirmService.confirm({
      header: this.translate.instant('DATA_PORTAL.ADMINISTRATION.AGE_GROUPS.DELETE_DIALOG_HEADER'),
      message: this.translate.instant('DATA_PORTAL.ADMINISTRATION.AGE_GROUPS.DELETE_DIALOG_BODY'),
      accept: () => {
        this.administrationRestService.getAgeGroupStatus(ageGroup).subscribe(isAgeGroupUsed => {
            if (isAgeGroupUsed) {
              this.confirmService.confirm({
                header: this.translate.instant('DATA_PORTAL.ADMINISTRATION.AGE_GROUPS.SECOND_DELETE_DIALOG_HEADER'),
                message: this.translate.instant('DATA_PORTAL.ADMINISTRATION.AGE_GROUPS.SECOND_DELETE_DIALOG_BODY'),
                accept: () => {
                  this.administrationRestService.deleteAgeGroup(ageGroup).subscribe(data => {
                    this.message.showSuccessMessage(
                      this.translate.instant('DATA_PORTAL.ADMINISTRATION.AGE_GROUPS.AGE_GROUP_DELETE_SUCCESS'));
                    this.loadData(0);
                  });
                }, reject: () => {
                  this.message.showInfoMessage(this.translate.instant(
                    ('DATA_PORTAL.ADMINISTRATION.AGE_GROUPS.AGE_GROUP_DELETE_CANCELLED')));
                }
              });
            } else {
              this.administrationRestService.deleteAgeGroup(ageGroup).subscribe(data => {
                this.message.showSuccessMessage(this.translate.instant('DATA_PORTAL.ADMINISTRATION.AGE_GROUPS.AGE_GROUP_DELETE_SUCCESS'));
                this.loadData(0);
              });
            }
          }
        );
      }, reject: () => {
        this.message.showInfoMessage(this.translate.instant('DATA_PORTAL.ADMINISTRATION.AGE_GROUPS.AGE_GROUP_DELETE_CANCELLED'));
      }
    });
  }
}
